/* Cart drawer suggestions: <fh-cart-recs> loads sections/fh-cart-upsell each time the drawer re-renders,
   and its arrows move the row one card at a time. */
(function () {
  "use strict";
  /* Remove means remove: Milano asks "Add to wishlist before remove?" only while the button has
     .action-add-wishlist, so drop that class before its own click handler runs. */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("mini-cart-remove-button.action-add-wishlist");
    if (btn) btn.classList.remove("action-add-wishlist");
  }, true);
  if (!window.customElements || customElements.get("fh-cart-recs")) return;
  customElements.define("fh-cart-recs", class extends HTMLElement {
    connectedCallback() {
      var self = this, slot = this.querySelector(".fh-cr-slot");
      if (!slot || !this.dataset.url) return;
      fetch(this.dataset.url, { credentials: "same-origin" })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var list = new DOMParser().parseFromString(text, "text/html").querySelector(".fh-cr-list");
          if (!list || !list.children.length) return;
          slot.replaceChildren(document.importNode(list, true));
          self.hidden = false;
          self.arrows(slot.firstElementChild);
        })
        .catch(function () {});
    }
    arrows(list) {
      var prev = this.querySelector("[data-fh-cr-prev]"), next = this.querySelector("[data-fh-cr-next]");
      if (!prev || !next) return;
      var step = function () {
        var card = list.firstElementChild;
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0) : list.clientWidth;
      };
      var sync = function () {
        var max = list.scrollWidth - list.clientWidth - 2;
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= max;
        prev.parentElement.hidden = max <= 0;
      };
      prev.addEventListener("click", function () { list.scrollBy({ left: -step(), behavior: "smooth" }); });
      next.addEventListener("click", function () { list.scrollBy({ left: step(), behavior: "smooth" }); });
      list.addEventListener("scroll", sync, { passive: true });
      sync();
    }
  });
})();

/* Search overlay: live suggestions (products + collections) from Shopify's predictive search while typing.
   Enter still submits to /search as before; "Popular categories" hides while results show. */
(function () {
  "use strict";
  var input = document.getElementById("fh-search-q");
  var form = input && input.form;
  var row = form && form.closest(".fh-search-row");
  if (!row) return;
  var popular = row.parentElement.querySelector(".fh-search-popular");
  var box = document.createElement("div");
  box.className = "fh-search-results";
  box.hidden = true;
  box.setAttribute("aria-live", "polite");
  row.insertAdjacentElement("afterend", box);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var timer = null, ctrl = null, last = "";
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var money = function (v) { var n = Number(v); return isNaN(n) ? "" : "Rs. " + n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var img = function (u, w) { if (!u) return ""; return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w; };
  var all = function (q) { return root + "search?q=" + encodeURIComponent(q) + "&options%5Bprefix%5D=last"; };
  var show = function (on) { box.hidden = !on; if (popular) popular.hidden = on; };
  var render = function (q, data) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [], cols = res.collections || [];
    if (!products.length && !cols.length) {
      box.innerHTML = '<p class="fh-sr-empty">No products found for “' + esc(q) + '”.</p>';
      show(true); return;
    }
    var html = "";
    if (products.length) {
      html += '<p class="fh-search-label">Products</p><ul class="fh-sr-list">';
      products.forEach(function (p) {
        var price = p.price_min && p.price_max && p.price_min !== p.price_max ? "From " + money(p.price_min) : money(p.price);
        var src = p.featured_image && p.featured_image.url || p.image;
        html += '<li><a class="fh-sr-item" href="' + esc(p.url) + '">' +
          '<span class="fh-sr-media">' + (src ? '<img src="' + esc(img(src, 200)) + '" srcset="' + esc(img(src, 200)) + ' 200w, ' + esc(img(src, 400)) + ' 400w" sizes="120px" alt="" loading="lazy">' : "") + "</span>" +
          '<span class="fh-sr-text"><span class="fh-sr-name">' + esc(p.title) + '</span><span class="fh-sr-price">' + esc(price) + "</span></span></a></li>";
      });
      html += "</ul>";
    }
    if (cols.length) {
      html += '<p class="fh-search-label">Collections</p><div class="fh-search-tags">';
      cols.forEach(function (c) { html += '<a href="' + esc(c.url) + '">' + esc(c.title) + "</a>"; });
      html += "</div>";
    }
    html += '<a class="fh-sr-all" href="' + esc(all(q)) + '">View all results for “' + esc(q) + '”</a>';
    box.innerHTML = html;
    show(true);
  };
  var run = function () {
    var q = input.value.trim();
    if (q === last) return;
    last = q;
    if (ctrl) ctrl.abort();
    if (q.length < 2) { box.innerHTML = ""; show(false); return; }
    ctrl = window.AbortController ? new AbortController() : null;
    var url = root + "search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=6" +
      "&resources%5Boptions%5D%5Bunavailable_products%5D=last&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title%2Ctag";
    fetch(url, { credentials: "same-origin", signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (input.value.trim() === q) render(q, data); })
      .catch(function () {});
  };
  input.addEventListener("input", function () { clearTimeout(timer); timer = setTimeout(run, 220); });
})();
